import { GQLOrganizationRegion } from '@upheal/graphql/definitions/schema.generated';

type MeteredPricing = {
    pricePerSession: number;
    providerCapPrice: number;
    currency: string;
};

const METERED_PRICING_BY_REGION: Record<GQLOrganizationRegion, MeteredPricing> =
    {
        [GQLOrganizationRegion.US]: {
            pricePerSession: 1.0,
            providerCapPrice: 69,
            currency: 'USD',
        },
        [GQLOrganizationRegion.CA]: {
            pricePerSession: 1.0,
            providerCapPrice: 69,
            currency: 'CAD',
        },
        [GQLOrganizationRegion.UK]: {
            pricePerSession: 0.7,
            providerCapPrice: 49,
            currency: 'GBP',
        },
        [GQLOrganizationRegion.AU]: {
            pricePerSession: 1.45,
            providerCapPrice: 100,
            currency: 'AUD',
        },
        [GQLOrganizationRegion.NZ]: {
            pricePerSession: 1.7,
            providerCapPrice: 119,
            currency: 'NZD',
        },
        [GQLOrganizationRegion.EU]: {
            pricePerSession: 0.85,
            providerCapPrice: 59,
            currency: 'EUR',
        },
        [GQLOrganizationRegion.Other]: {
            pricePerSession: 1.0,
            providerCapPrice: 69,
            currency: 'USD',
        },
    };

export const getMeteredPricingForRegion = (
    region: GQLOrganizationRegion | undefined,
): MeteredPricing =>
    METERED_PRICING_BY_REGION[region ?? GQLOrganizationRegion.US];
